import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Slider from "@material-ui/core/Slider";

const marks = [12.5, 37.5, 62.5, 87.5];
const useStyles = makeStyles({
  root: {
    alignItems: 'center',
  },
  thumb: {
    background: "white",
    marginLeft: "-0.85rem",
    width: '1.7rem',
    height:'1.7rem',
    border: '1px solid grey',
    "&~&": {
      background: "transparent"
    },
    'z-index': '2'
  },
  mark: {
    display: 'none'
  },
  rail: {
    height: '1rem',
    opacity: '100%',
    border: "solid 1px black",
    background: "linear-gradient(to left, #FFFFFF 25%, #ED1C24 26%, #ED1C24 50%, #FFD300 51%, #FFD300 75%, #0D7F3F 76%);"
  },
  track: {
    background: "transparent"
  },
  valueLabel: {
    "&>*": {
      background: "transparent"
    }
  }
});

const ColoredSlider = (props) => {
    const firstBreakpoint = useMediaQuery('(max-width:1400px)');
    const secondBreakpoint = useMediaQuery('(max-width:1100px)');
    const classes = useStyles(props);
    let colorValue = null;


    const onChange = (e, value) => {  

      if (value === marks[0]) {
        colorValue = "Green";
      } else if (value === marks[1]) {
        colorValue = "Yellow";
      } else if (value === marks[2]) {
        colorValue = "Red";
      } else if (value === marks[3]) {
        colorValue = "NA";
      }   

      props.onChange(e, colorValue, props.name);
    };

    const printedValue = (value) => {
      if (value === "Green") {
        return marks[0];
      } else if (value === "Yellow") {
        return marks[1];
      } else if (value === "Red") {
        return marks[2];
      } else if (value === "NA") {
        return marks[3];
      } else {
        return -1;
      } 
    }

    const naStyle = {
      position:'absolute',
      right:  '0.75rem',
      top:'40%',
      zIndex:'1',
      fontSize: '1rem',
      pointerEvents:'none'
    };

    if(firstBreakpoint){
      naStyle.right = '0.6rem';
      naStyle.fontSize = '0.8rem';
      if(secondBreakpoint){
        naStyle.right = '0.5rem';
        naStyle.fontSize = '0.6rem';
      }
    }

    return (
      <div className={classes.root} style={({position:'relative'})}>
        <Slider
          classes={{
            thumb: classes.thumb,
            rail: classes.rail,
            track: classes.track,
            valueLabel: classes.valueLabel,
            mark: classes.mark
          }}
          marks={marks.map(value => ({value: value}))}
          defaultValue={0}
          valueLabelDisplay="off"
          value={printedValue(props.value)}
          step={null}
          onChange={onChange}
        />
        <div style={naStyle}>N/A</div>
    </div>
  )
};

export { ColoredSlider };